import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { OneMapResponse } from '../type';
import { OneMapAddress } from '../model';

@Injectable({ providedIn: 'root' })
export class OneMapApiService {
  private readonly http = inject(HttpClient);
  private readonly endpoint = 'https://www.onemap.gov.sg/api/common/elastic/search';

  /**
   * Performs a search using the OneMap API.
   * Read more at https://www.onemap.gov.sg/docs/#search
   *
   * @param params - The search parameters.
   * @returns An Observable that emits an array of OneMap objects.
   */
  search(params: {
    searchVal: string;
    returnGeom: 'Y' | 'N';
    getAddrDetails: 'Y' | 'N';
    pageNum?: string;
  }): Observable<OneMapAddress[]> {
    return this.http
      .get<OneMapResponse>(this.endpoint, { params })
      .pipe(map(res => res.results.map(v => OneMapAddress.fromJson(v))));
  }

  get(postal: string): Observable<OneMapAddress | null> {
    return this.http
      .get<OneMapResponse>(this.endpoint, { params: { searchVal: postal, returnGeom: 'N', getAddrDetails: 'Y' } })
      .pipe(map(res => (res.results && res.results.length ? OneMapAddress.fromJson(res.results[0]) : null)));
  }
}
